import clsx from 'clsx';

import { Icon } from '@gitbook/spine-icons';

import { useSegmentedControlContext } from '../SegmentedControlContext';

export type CardCheckProps = {
    size?: number;
    className?: string;
};

/**
 * Represents the checkmark of a card, indicating the selection state.
 */
export function CardCheck(props: CardCheckProps) {
    const state = useSegmentedControlContext();

    return (
        <div
            className={clsx(
                'inline-flex shrink-0 rounded-full border transition-shadow duration-0 motion-safe:duration-300',

                state.isSelected && 'border-primary bg-action-primary shadow-selected-ring',
                props.className
            )}
        >
            <Icon.AnimatedCheck
                size={props.size ?? 16}
                isSelected={state.isSelected}
                className="shrink-0 text-white"
            />
        </div>
    );
}
